module.exports = __webpack_public_path__ + "img/朱砂.67166dc3.jpg";